import { Component, OnInit, Input } from '@angular/core';
import { Video } from '../../classes/video';

declare var YT: any;
declare var jQuery: any;

@Component({
  selector: 'app-video-book-page',
  templateUrl: './video-book-page.component.html',
  styleUrls: ['./video-book-page.component.css']
})
export class VideoBookPageComponent implements OnInit {

  @Input() video?: Video;
  constructor() { }

  onStateChange = function(event: any) {
    console.log('STATE', event);
  };

  ngOnInit() {
    const localVid = this.video;
    const comp = this;

    jQuery(document).ready(function() {
      const player = new YT.Player('ytplayer', {
        videoId: localVid.id,
        events: {
          'onReady': function(event: any) {
            console.log('READY 2', event);
          },
          'onStateChange': comp.onStateChange
        }
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/video-book-page/video-book-page.component.ts